import React from "react";
import { Link } from "react-router-dom";

const menuItems = [
  {
    title: "Feedback",
    description:
      "Manage feedback, complaints, and commendations in one place",
    path: "/features/feedback",
    icon: (
      <svg
        className="mega-menu-icon w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M21 15a4 4 0 01-4 4H8l-5 3V7a4 4 0 014-4h10a4 4 0 014 4z" />
      </svg>
    ),
  },
  {
    title: "Branches",
    description: "Track feedback by branch, HQ sees everything",
    path: "/features/branches",
    icon: (
      <svg
        className="mega-menu-icon w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M3 21V3h8v18M13 9h8v12h-8" />
      </svg>
    ),
  },
  {
    title: "Email Campaign",
    description:
      "Engage customers with automated, targeted emails",
    path: "/features/email-campaign",
    icon: (
      <svg
        className="mega-menu-icon w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M4 4h16v16H4z" />
        <path d="M22 6l-10 7L2 6" />
      </svg>
    ),
  },
  {
    title: "Forms",
    description:
      "Create powerful feedback forms, link them dynamically",
    path: "/features/forms",
    icon: (
      <svg
        className="mega-menu-icon w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M6 2h9l5 5v15H6z" />
        <path d="M14 2v6h6" />
      </svg>
    ),
  },
  {
    title: "Department",
    description:
      "Organize feedback by department, assign clear owners",
    path: "/features/department",
    icon: (
      <svg
        className="mega-menu-icon w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M16 3H8v4h8z" />
      </svg>
    ),
  },
];

const MegaMenu = ({ onItemClick }) => {
  return (
    <div className="mega-menu-enter absolute left-0 top-full w-full pt-3 md:pt-4 px-3 sm:px-4 md:px-6">
      <div className="max-w-7xl mx-auto bg-[#F7F6FB] rounded-2xl md:rounded-[40px] px-4 sm:px-8 lg:px-12 py-6 sm:py-10 lg:py-16 shadow-xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-8 sm:gap-y-12 lg:gap-y-16 gap-x-6 lg:gap-x-12">
          {menuItems.map((item, index) => (
            <Link
              to={item.path}
              key={index}
              onClick={onItemClick}
              className="mega-menu-link group block transition"
            >
              {/* Icon */}
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl bg-white shadow-sm flex items-center justify-center mb-4 sm:mb-6 group-hover:shadow-md transition">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="mega-menu-title text-base sm:text-lg font-semibold text-gray-900 mb-2 transition">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed max-w-xs">
                {item.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
